import { graphql } from "react-relay";
import { ChromeFeed } from "./ChromeFeed";

export const queries = graphql`
  query ChromeFeedRendererQuery {
    viewer {
      ...ChromeFeed_viewer
    }
  }
`;
